import PageHeader from '../components/layout/PageHeader';
import TeamSections from '../components/team/TeamSections';
import usePageTitle from '../hooks/usePageTitle';

const INTRO =
  'Our team consists of certified veterinarians experienced in all things animal care. With professionals specializing in surgery, dermatology, cancer treatment, and grooming, you can be sure your pets will be well taken care of.';

export default function Team() {
  usePageTitle('Our Staff');

  return (
    <>
      <PageHeader eyebrow="Our Staff" title="Meet Our Team" intro={INTRO} />
      <TeamSections />
    </>
  );
}
